export const addJumpToWizardText = {
  title: 'Select the lesson node to jump to',
  inputTitle: 'Choice option',
  placeholder: 'Option',
  cancel: 'Cancel',
  accept: 'Accept',
  lessonNodes: 'Lesson Nodes:',
};
